/* @flow */

import { errorColor } from '@e180/ui/lib/token/color';

export default {
  root: {
    display: 'block',

    color: errorColor,

    fontStyle: 'italic',
    textAlign: 'right',
    WebkitFontSmoothing: 'antialiased',
  },
};
